// TODO(carpita): Select language at run time and integrate with existing Spotify lang frameworks

const bindings = {
  'build-voice-over': 'Build a Voiceover',
  'transcript-placeholder': 'Transcript',
  'name-placeholder': 'Name',
  'instructions-placeholder': 'Instructions',
  'enter-your-script': 'Enter Your Script',
  'enter-your-script-instructions': 'Script of Voiceover: up to 2000 characters.',
  'error-empty-transcript': 'You must enter content for the voice-over transcript.',
  'error-empty-name': 'You must label your voice-over with a name.',
  'server-error': 'A server error occurred while attempting to create a voice-over',
};

export default function getBinding(key, defaultValue) {
  if (bindings.hasOwnProperty(key)) {
    return bindings[key];
  }
  return defaultValue;
}

export function setLocale(/* locale */) {
  // ...
}

getBinding.setLocale = setLocale;



// WEBPACK FOOTER //
// ./src/config/lang.js